import type { MouseEvent } from 'react';

export const redirectLink = (
	e: MouseEvent<HTMLAnchorElement>,
	link: string,
	callback?: () => void,
): void => {
	e.preventDefault();
	callback?.();

	window.location.href = link;
};
